import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import GuideLayout from '../../../layout/GuideLayout';
import GuideHeader from '../../../layout/header/GuideHeader';

export default function Korail5() {
	const images = [
		require('../../../asset/jpg/korailFirst.jpg'),
		require('../../../asset/jpg/korail-5/1.jpg'),
		require('../../../asset/jpg/korail-5/2.jpg'),
		require('../../../asset/jpg/korail-5/3.jpg'),
		require('../../../asset/jpg/korail-5/4.jpg'),
		require('../../../asset/jpg/korail-5/5.jpg'),
		require('../../../asset/jpg/korail-5/6.jpg'),
	];

	const navigate = useNavigate();
	const [currentImgIdx, setCurrentImgIdx] = useState(0);

	const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const halfScreenWidth = window.innerWidth / 2;

		if (e.clientX < halfScreenWidth) {
			// 왼쪽 클릭시, 이전 이미지로
			if (currentImgIdx > 0) {
				setCurrentImgIdx(currentImgIdx - 1);
			}
		} else {
			// 오른쪽 클릭시, 다음 이미지로
			if (currentImgIdx < images.length - 1) {
				setCurrentImgIdx(currentImgIdx + 1);
			} else {
				navigate('/guide/korail');
			}
		}
	};

	return (
		<GuideLayout>
			<GuideHeader
				title="구매한 승차권을 환불하고 싶어요"
				page="/guide/korail"
			/>
			<ImgSlider onClick={(e) => handleClick(e)}>
				<ImgBox src={images[currentImgIdx]} alt="korail guide" />
			</ImgSlider>
		</GuideLayout>
	);
}

const ImgSlider = styled.div``;

const ImgBox = styled.img`
	width: 100%;
	height: 100%;
`;
